/* eslint-disable @reatom/unit-naming-rule */
import { reatomResource } from '@root/shared/lib'

import { fetchWalletDegenHoursRequestAction } from './wallet-degen-hours-requests'

import type { Address } from '@root/entities/address/Address'
import type { Network } from '@root/entities/network'

/**
 * How far back a wallet's hours are counted.
 *
 * Its own window rather than the profile's period, which is how Axiom does
 * it too: a heatmap of the last hour is one square, and the point of the
 * thing is the shape of a whole week. Thirty days is enough weeks to have a
 * shape and measured at 214ms for the busiest wallet in the system.
 */
const DAYS = 30

/** Loads when the tab that shows it is mounted, and not before. */
export const reatomWalletDegenHours = ({
  walletAddress,
  network,
}: {
  walletAddress: Address
  network: Network.Network
}) =>
  reatomResource(
    async (ctx) =>
      ctx.schedule(() =>
        fetchWalletDegenHoursRequestAction(ctx, {
          network,
          walletAddress,
          days: DAYS,
        }),
      ),
    { name: 'reatomWalletDegenHours', loadOnConnect: true },
  )
